<div class="ds-stat-tab-group__scroller" role="tablist" [attr.aria-label]="ariaLabel">
  <ng-content></ng-content>
</div>

<div class="ds-stat-tab-group__dots" aria-hidden="true">
  <span
    *ngFor="let tab of tabs || []"
    class="ds-stat-tab-group__dot"
    [class.ds-stat-tab-group__dot--active]="tab.active"
  ></span>
</div>
